import React, { useState, useEffect } from "react";
import Admin from "./Admin";
import "../../styles/admin.css";

export default function AdminTeams({ addToast }) {
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [showModal, setShowModal] = useState(false);

  // Szerkesztett értékek
  const [leagueId, setLeagueId] = useState(null);
  const [name, setName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");


  const handleSave = () => {
    // Hozzáadás
    if (!selectedTeam) {
      const newTeam = {
        league_id: leagueId,
        short_name: name,
        logo_url: logoUrl
      };

      fetch("https://focifanatik.hu/api/admin_add_teams.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newTeam)
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            addToast("Új csapat sikeresen hozzáadva!", "success")
            handleCloseModal();

            // Frissítsük a listát
            fetch("https://focifanatik.hu/api/admin_teams.php")
              .then(r => r.json())
              .then(d => setTeams(d));
          } else {
            addToast("Hiba!", "warning")
          }
        })
        .catch(err => console.error("Hálózati hiba:", err));

      return; // itt megállunk, nem megyünk tovább a szerkesztéses részre
    };


    // Szerkesztés
    const updatedData = {};
    if (leagueId !== selectedTeam.league_id) updatedData.league_id = leagueId;
    if (name !== selectedTeam.short_name) updatedData.short_name = name;
    if (logoUrl !== selectedTeam.logo_url) updatedData.logo_url = logoUrl;

    if (Object.keys(updatedData).length === 0) {
      addToast("Nem történt módositás!", "warning")
      return;
    }

    fetch(`https://focifanatik.hu/api/admin_update_teams.php?id=${selectedTeam.id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          addToast("Sikeres mentés!", "success")
          handleCloseModal();

          fetch("https://focifanatik.hu/api/admin_teams.php")
            .then((r) => r.json())
            .then((d) => setTeams(d));
        } else {
          addToast("Hiba!", "warning")
        }
      })
      .catch((err) => console.error("Hálózati hiba:", err));

  };



  useEffect(() => {
    // FONTOS: pontos URL
    fetch("https://focifanatik.hu/api/admin_teams.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
        setTeams(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, []);




  const handleOpenModal = (team) => {
    setSelectedTeam(team);
    setLeagueId(team.league_id);
    setName(team.short_name);
    setLogoUrl(team.logo_url);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedTeam(null);
  };
  return (
    <div className="admin-page">
      <Admin />
      <main className="admin-content">
        <header className="admin-header">
          <h3>🏆 Csapatok kezelése</h3>
        </header>

        <section className="admin-main">
          <p className="text-muted">Itt tudod kezelni a csapatokat.</p>

          <button
            className="btn btn-success mb-3"
            onClick={() => {
              // kiürítjük a mezőket és megnyitjuk az üres modalt
              setSelectedTeam(null);
              setLeagueId("");
              setName("");
              setLogoUrl("");
              setShowModal(true);
            }}
          >
            <i className="bi bi-plus-circle"></i> Új csapat hozzáadása
          </button>

          <div className="table-responsive mt-4">
            <table className="table table-striped text-center align-middle">
              <thead className="table-success">
                <tr>
                  <th>ID</th>
                  <th>League ID</th>
                  <th>Name</th>
                  <th>Logó</th>
                  <th>Létrehozva</th>
                  <th>Műveletek</th>
                </tr>
              </thead>
              <tbody>
                {teams.map((l) =>
                  <tr key={l.id}>
                    <td>{l.id}</td>
                    <td>{l.league_id}</td>
                    <td>{l.short_name}</td>
                    <td>{l.logo_url}</td>
                    <td>{l.created_at}</td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-sm btn-warning" onClick={() => handleOpenModal(l)}>
                          <i className="bi bi-pencil-square"></i> Szerkesztés
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>

      {showModal && (
        <>
          {/* Sötét háttér */}
          <div className="custom-modal-backdrop"></div>

          <div className="custom-modal d-flex justify-content-center align-items-center">
            <div className="custom-modal-content">

              {/* CÍM */}
              <div className="custom-modal-header">
                <h5 className="modal-title-custom">
                  {selectedTeam ? "Csapat szerkesztése" : "Új csapat"}
                </h5>
                <button className="close-btn" onClick={handleCloseModal}>×</button>
              </div>


              {/* TARTALOM */}
              <div className="custom-modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">League ID</label>
                    <input
                      type="number"
                      className="form-control"
                      value={leagueId}
                      onChange={(e) => setLeagueId(e.target.value)}
                      placeholder="Pl. Barcelona"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Pl. Barcelona"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Logo Url</label>
                    <input
                      type="text"
                      className="form-control"
                      value={logoUrl}
                      onChange={(e) => setLogoUrl(e.target.value)}
                      placeholder="Pl. Barcelona"
                    />
                  </div>
                </form>
              </div>

              {/* LÁB */}
              <div className="custom-modal-footer">
                <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                  Mégse
                </button>
                <button className="pretty-btn save-btn" onClick={handleSave}>
                  Mentés
                </button>
              </div>


            </div>
          </div>
        </>
      )}

    </div>
  );
}
